export const ToolsCard = ({ imgUrl, tools, description }) => {
    return (
        <div className="toolsCard-imgbx">
            <img src={imgUrl} alt="imgUrl" className="toolsCard-img" align="left" />
            <div className="toolsCard-txt">
                <h5>{tools}</h5>
                <p>{description}</p>
            </div>
        </div>

    )
}